<template>
  <Cascader size="large" :options="filterOptions" placeholder="请选择" @change="onChange"></Cascader>
</template>
<script setup lang="ts">
import { Cascader } from 'ant-design-vue'
import city from './city.json'
import { computed } from 'vue'

type Props = {
  /**
   * 可用的层级
   * - 1 只选择省
   * - 2 只选择省市
   * - 3 选择省市区。默认
   *  */
  level?: 1 | 2 | 3
}

const props = withDefaults(defineProps<Props>(), {
  level: 3,
})

const filterOptions = computed(() => {
  if (props.level === 3) {
    const result = [] as AnyObject[]
    city.forEach((p: AnyObject) => {
      result.push({
        label: p.label,
        value: p.label,
        children: p.children.map((c: AnyObject) => ({
          label: c.label,
          value: c.label,
          children: c.children.map((d: AnyObject) => ({
            label: d.label,
            value: d.label,
            children: undefined,
          })),
        })),
      })
    })
    return result
  }

  if (props.level === 2) {
    const result = [] as AnyObject[]
    city.forEach((p: AnyObject) => {
      result.push({
        label: p.label,
        value: p.label,
        children: p.children.map((c: AnyObject) => ({
          label: c.label,
          value: c.label,
          children: undefined,
        })),
      })
    })
    return result
  }

  if (props.level === 1) {
    const result = [] as AnyObject[]
    city.forEach((p: AnyObject) => {
      result.push({
        label: p.label,
        value: p.label,
        children: undefined,
      })
    })
    return result
  }

  return []
})

const emit = defineEmits(['input'])
function onChange(val: string, selectedOptions: { label: string; value: string }[]) {
  emit('input', val)
  // console.log(1212, val, selectedOptions)
}
</script>
<style lang="less" scoped></style>
